export default __webpack_public_path__ + "static/logo_positive_mono_mark-a5b468eb3d620472c3b944cf789e14b0.svg";